import { Component, EventEmitter, OnChanges, Input, Output } from '@angular/core';

import { MonitoringFilters } from '@classes/monitoring/monitoring-filters';
import { MonitoringFilterItem } from '@classes/monitoring/monitoring-filter-item';

@Component({
  selector: 'app-monitoring-filters',
  templateUrl: './monitoring-filters.component.html',
  styleUrls: ['./monitoring-filters.component.scss']
})
export class MonitoringFiltersComponent implements OnChanges {

    @Input() @Output() filters = new MonitoringFilters();

    @Input() isLoading = false;

    @Output() selectionChange = new EventEmitter<MonitoringFilters>();

    visibleRegions:        MonitoringFilterItem[] = [];
    visibleProvinces:      MonitoringFilterItem[] = [];
    visibleMunicipalities: MonitoringFilterItem[] = [];
    visibleRoles:          MonitoringFilterItem[] = [];
    visibleLicenceTypes:   MonitoringFilterItem[] = [];
    visibleBankers:        MonitoringFilterItem[] = [];

    isEmpty = true;

    constructor () {}

    ngOnChanges (): void { this.update(); }

    onSelectionChange (items: MonitoringFilterItem[]) {
        if (items && items[0]) {
            this.update(items[0].category);
        }
    }

    onStartDateChange (date: Date) { this.filters.startDate = date; this.updateIsEmpty(); }
    onEndDateChange   (date: Date) { this.filters.endDate   = date; this.updateIsEmpty(); }

    public onSubmit (): void {
        this.selectionChange.emit(this.filters);
    }

    private update (current = "") {
        if (!this.filters.items) { this.filters.items = []; }
        const items = this.filters.items;

        const regions        = items.filter(i => i.category === 'region'      );
        const provinces      = items.filter(i => i.category === 'province'    );
        const municipalities = items.filter(i => i.category === 'municipality');
        const licenceTypes   = items.filter(i => i.category === 'licenceType' );
        const bankers        = items.filter(i => i.category === 'banker'      );

        switch (current)
        {
            case 'region':
                for (const region of regions) {
                    items
                        .filter(i => i.regionID === region.id)
                        .forEach(i => i.isSelected = i.isVisible = region.isSelected);
                }
                break;
            case 'province':
                for (const province of provinces) {
                    items
                        .filter(i => i.provinceID === province.id)
                        .forEach(i => i.isSelected = i.isVisible = province.isSelected);
                }
                break;
            case 'licenceType':
                for (const licenceType of licenceTypes) {
                    items
                        .filter(i => i.licenceTypeID === licenceType.id)
                        .forEach(i => i.isSelected = i.isVisible = licenceType.isSelected);
                }
                break;
            case 'banker':
                for (const banker of bankers) {
                    items
                        .filter(i => i.bankerID === banker.id)
                        .forEach(i => i.isSelected = i.isVisible = banker.isSelected);
                }
                break;
        }

        for (let municipality of municipalities)
        {
            municipality.isVisible =
                regions     .find(r => r.id === municipality.regionID     ).isSelected
            &&  provinces   .find(p => p.id === municipality.provinceID   ).isSelected
            &&  licenceTypes.find(t => t.id === municipality.licenceTypeID).isSelected
            &&  bankers     .find(b => b.id === municipality.bankerID     ).isSelected;

            if (!municipality.isVisible) { municipality.isSelected = false; }
        }

        if (current !== 'region'      ) { this.visibleRegions        = items.filter(f => f.isVisible && f.category === 'region'      ); }
        if (current !== 'province'    ) { this.visibleProvinces      = items.filter(f => f.isVisible && f.category === 'province'    ); }
        if (current !== 'municipality') { this.visibleMunicipalities = items.filter(f => f.isVisible && f.category === 'municipality'); }
        if (current !== 'role'        ) { this.visibleRoles          = items.filter(f => f.isVisible && f.category === 'role'        ); }
        if (current !== 'licenceType' ) { this.visibleLicenceTypes   = items.filter(f => f.isVisible && f.category === 'licenceType' ); }
        if (current !== 'banker'      ) { this.visibleBankers        = items.filter(f => f.isVisible && f.category === 'banker'      ); }

        this.updateIsEmpty();
    }

    private updateIsEmpty (): void {
        const hasDate = this.filters.endDate >= this.filters.startDate;

        const hasMunicipality = this.visibleMunicipalities.some(i => i.isSelected);
        const hasRole         = this.visibleRoles         .some(i => i.isSelected);
        const hasLicenceType  = this.visibleLicenceTypes  .some(i => i.isSelected);
        const hasBanker       = this.visibleBankers       .some(i => i.isSelected);

        this.isEmpty = !hasDate || !hasMunicipality || !hasRole || !hasLicenceType || !hasBanker;
    }

}
